import type { Agent } from '@wix/ambassador-appmarket-v1-app-market-client-aggregator/types';
import type { AgentDataType } from './types';

export class AgentData {
  constructor(private readonly agent: Agent) {}

  toJSON(): AgentDataType {
    return {
      title: this.agent.title ?? '',
      description: this.agent.description ?? '',
      icon: this.agent.icon ?? '',
      pageId: this.agent.pageId ?? '',
    };
  }
}
